// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"dd23ff54","682":"a313d7ef","956":"355ce966","966":"3b533f18"}[chunkId] + ".chunk.css";
};